import DOMPurify from "dompurify";

export function cleanHTML(input) {
  return DOMPurify.sanitize(input);
}

export const convertMetatagName = (metatag) =>
  metatag.toLowerCase().replace(/ /g, "-").replace(/%/g, "_");

export const recoverMetatagName = (metatag) =>
  metatag.toUpperCase().replace(/-/g, " ").replace(/_/, "%");

export const capitalizeFirstLetter = (text) => {
  if (!text) return text;
  return text.charAt(0).toUpperCase() + text.slice(1);
};
